export default {
  data: [
    {
      dairy: false,
      favorite: false,
      flavor: 'Black',
      premium: false
    },
    {
      dairy: false,
      favorite: false,
      flavor: 'Ginger',
      premium: false
    },
    {
      dairy: false,
      favorite: false,
      flavor: 'Grape',
      premium: false
    },
    {
      dairy: false,
      favorite: false,
      flavor: 'Green Apple',
      premium: false
    },
    {
      dairy: false,
      favorite: false,
      flavor: 'Honey',
      premium: false
    },
    {
      dairy: false,
      favorite: false,
      flavor: 'Jasmine',
      premium: false
    },
    {
      dairy: false,
      favorite: false,
      flavor: 'Kiwi',
      premium: false
    },
    {
      dairy: false,
      favorite: false,
      flavor: 'Lemon',
      premium: false
    },
    {
      dairy: false,
      favorite: false,
      flavor: 'Longan',
      premium: false
    },
    {
      dairy: false,
      favorite: false,
      flavor: 'Mango',
      premium: false
    },
    {
      dairy: false,
      favorite: false,
      flavor: 'Passion',
      premium: false
    },
    {
      dairy: false,
      favorite: false,
      flavor: 'Peach',
      premium: false
    },
    {
      dairy: false,
      favorite: false,
      flavor: 'Peppermint',
      premium: false
    },
    {
      dairy: false,
      favorite: false,
      flavor: 'Pomegranate',
      premium: false
    },
    {
      dairy: false,
      favorite: false,
      flavor: 'Raspberry',
      premium: false
    },
    {
      dairy: false,
      favorite: false,
      flavor: 'Rose',
      premium: true
    },
    {
      dairy: false,
      favorite: false,
      flavor: 'Sour Plum',
      premium: false
    },
    {
      dairy: false,
      favorite: false,
      flavor: 'Strawberry',
      premium: false
    },
    {
      dairy: false,
      favorite: false,
      flavor: 'Yogurt',
      premium: false
    }
  ]
};



// WEBPACK FOOTER //
// ./src/js/iced_tea_flavors.js